export enum WindowType {
  YTD = "ytd",
  Y1 = "1y",
  Y3 = "3y",
  Y5 = "5y",
  ALL = "all",
}

export type SizeType = "sm" | "md" | "lg";

export type LinkedBrokersBlockedAction = "delete" | "deactivate";

export enum AccountType {
  SAVINGS = "Savings",
  INVESTMENTS = "Investments",
  CASH = "Cash",
  CHECKING = "Checking",
  LIABILITIES = "Liabilities",
  ACCOUNT = "Account",
  OTHER = "Other",
}

export enum TransactionType {
  ALL = "All",
  INCOME = "Income",
  EXPENSE = "Expense",
  TRANSFER = "Transfer",
  LOAN_PAYMENT = "Loan Payment",
  MARKET_UPDATE = "Market Update",
  INVESTMENT = "Investment", // not sure if needed
}

export type AuthProviderType = "local" | "google";

export type UserProfileType = {
  name: string;
  lastName: string;
  email: string;
  authProvider: AuthProviderType;
  dateOfBirth: string | null;
  ageVerificationExempt: boolean;
  isAdmin: boolean;
};

export enum DateFormat {
  ISO = "YYYY-MM-DD",
  DMY_SLASH = "DD/MM/YYYY",
  MDY_SLASH = "MM/DD/YYYY",
  DMY_SPACE = "DD MMM YYYY",
  DM_SPACE = "DD MMM",
  MY_SPACE = "MMM YYYY",
  MY_SHORT = "MMM YY",
  DMY_SHORT = "D MMM YY",
  DM_TIME = "D MMM, HH:mm",
}

export type CashbackMode = "NONE" | "CASH" | "INVESTED";

export interface CashbackSettings {
  cashbackMode?: CashbackMode;
  cashbackRate?: number;
  cashbackMonthlyCap?: number | null;
}

export interface CashbackSectionVisibilityParams {
  mode?: CashbackMode;
  invested: number;
  adjustmentCount: number;
}

export interface CashbackInUseParams {
  mode?: CashbackMode;
  received: number;
  invested: number;
  paidElsewhere: number;
}

export interface AddCashbackToBalanceParams {
  mode?: CashbackMode;
  received: number;
}

export interface CashbackSourceAccount extends CashbackSettings {
  id: number;
  name: string;
  accountType: AccountType;
  currencyCode: string;
}

export interface CashbackSourceOptionsParams {
  accounts: CashbackSourceAccount[] | undefined;
  /** Unset lists every currency, e.g. before the destination is picked. */
  currencyCode?: string;
  selected?: CashbackSourceOption | null;
}

export interface CashbackSourceOption {
  value: string;
  label: string;
}

export interface CashbackFormValues {
  cashbackMode?: CashbackMode;
  cashbackRate?: string;
  cashbackMonthlyCap?: string | null;
}

export interface AccountLifespan {
  startDate: string;
  deactivationDate?: string;
  isActive: boolean;
}
